import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
    selector: 'app-confirm',
    template: `<div class="p-4">
    <h1 class="text-lg pl-1 !mb-2">{{ data.title }}</h1>
    <div class="mb-4 pl-1" *ngIf="!!data.message">{{ data.message }}</div>
    <div
      style=" display: flex;
		justify-content: flex-end;
		padding: 10px 0px;"
    >
     <button style= "margin-right: 10px"
        type="button"
        mat-raised-button
        color="primary"
        (click)="dialogRef.close(true)"
      >
        OK
      </button>
       <button
        mat-raised-button
        type="button"
        color="accent"
        (click)="dialogRef.close(false)"
      >
        Cancel
      </button>
    </div>
  </div>`,
    standalone: false
})
export class AppComfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<AppComfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
